import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=18b937cf&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=18b937cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b937cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b937cf')) {
      api.createRecord('18b937cf', component.options)
    } else {
      api.reload('18b937cf', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=18b937cf&scoped=true&", function () {
      api.rerender('18b937cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2v7yTtA7zCrv9/JS/comp/SearchFilterTokens.vue"
export default component.exports